export const PROPERTY_SPACE_PERSON_sv = {
  translation: {
    actions: {
      createApartment: 'Skapa ny lokal',
      bulk: {
        deleteResidentsMessage: 'Är du säker på att du vill ta bort {{count}} valda personer?',
        deleteApartmentsMessage: 'Är du säker på att du vill ta bort {{count}} valda lokaler?',
        deleteCondominiumsMessage: 'Är du säker på att du vill ta bort {{count}} valda fastigheter?',
        editResidentsTitle: 'Redigera personer',
        editApartmentsTitle: 'Redigera lokaler',
        editCondominiumsTitle: 'Redigera fastigheter',
        selectResidentApartment: 'Välj lokal',
      },
    },
    keys: {
      condominium: 'Fastighet',
      apartment: 'Lokal',
      handoverInstructions: 'Instruktioner för nyckelöverlämning',
      handoverInstructionsPlaceholder: 'Skriv instruktioner för nyckelöverlämning och återlämning',
      resident: 'Person',
    },
    key: {
      handoverAddFromDirectory: 'Via fastighet eller lokal',
      handoverDirectoryHint:
        'Välj fastighet eller lokal, eller skriv minst två tecken i sökfältet (stämpel, adress, fastighet).',
      handoverDirectoryNoQuery: 'Välj fastighet eller lokal, eller skriv minst 2 tecken för att söka.',
      handoverAddResident: 'Skapa ny person',
    },
    common: {
      space: 'Lokal',
    },
    apartment: {
      apartments: 'Lokaler',
      deleteTitle: 'Ta bort lokal',
      deleteMessage: 'Är du säker på att du vill ta bort denna lokal? Denna åtgärd kan inte ångras.',
      apartment: 'Lokal',
    },
    apartments: {
      title: 'Lokaler',
      searchPlaceholder: 'Sök lokaler...',
      editApartment: 'Redigera lokal',
      apartment: 'Lokal',
      defaultTitle: 'Lokal',
      notFoundDescription: 'Den begärda lokalen hittades inte eller du har inte behörighet att visa den.',
      residents: 'Personer',
      deleteResidentTitle: 'Ta bort person',
      deleteResidentMessage: 'Är du säker på att du vill ta bort personen',
      createNew: 'Skapa ny lokal',
      createMultiple: 'Skapa flera lokaler',
      multipleLabel: 'Skapa flera lokaler',
      multipleDescription: 'Aktivera för att skapa flera lokaler på en gång med ett nummerintervall',
      condominium: 'Fastighet',
      selectCondominium: 'Välj fastighet',
      createMultipleDescription: 'Skapa flera lokaler på en gång med ett nummerintervall',
      addResident: 'Lägg till person',
      condominiumRequired: 'Fastighet krävs',
      residentsCount: 'Personer',
      showEmptyOnly: 'Endast lokaler utan personer',
    },
    validation: {
      condominiumRequired: 'Fastighet krävs',
      apartmentRequired: 'Lokal krävs',
    },
    residents: {
      title: 'Personer',
      searchPlaceholder: 'Sök personer...',
      editResident: 'Redigera person',
      createResident: 'Skapa ny person',
      apartment: 'Lokal',
      apartmentRequired: 'Lokal krävs',
      selectApartment: 'Välj lokal',
      noResidentsFound: 'Inga personer hittades',
      noResidentsWithoutApartment: 'Alla personer har redan en lokal',
    },
    wizard: {
      title: 'Snabbinstallation av fastighet',
      subtitle: 'Skapa fastighet, lokaler, personer och nycklar på en gång',
      steps: {
        condominium: 'Fastighet',
        apartments: 'Lokaler',
        residents: 'Personer',
      },
      stepDescriptions: {
        condominium: 'Skapa en ny fastighet genom att fylla i grunduppgifterna',
        apartments: 'Lägg till lokaler i fastigheten individuellt eller i bulk',
        residents: 'Lägg till personer och koppla dem till lokaler',
      },
      actions: {
        addApartment: 'Lägg till lokal',
        addResident: 'Lägg till person',
      },
      info: {
        noApartmentsForResidents: 'Lägg till lokaler först innan du lägger till personer.',
      },
      apartmentsList: 'Lokaler',
      residentsList: 'Personer',
    },
    general: {
      noApartments: 'Inga lokaler',
      noResidents: 'Inga personer',
      emptyFilterShort: 'Tomma',
      showBulkDelete: 'Visa massradering i tabeller',
      showBulkDeleteDescription:
        'Aktivera val och borttagning av flera objekt i tabeller för lokaler, personer, fastigheter och nycklar.',
    },
    condominiums: {
      apartmentKeyType: 'Fastighetsnyckeltyp',
    },
    condominium: {
      header: 'Fastigheter',
      condominiums: 'Fastigheter',
      condominiumDetails: 'Fastighetsuppgifter',
      name: 'Fastighet',
      superIntendent: 'Förvaltare',
      selectSuperIntendent: 'Välj förvaltare...',
      create: 'Skapa fastighet',
      edit: 'Redigera fastighet',
      update: 'Uppdatera fastighet',
      deleteTitle: 'Ta bort fastighet',
      deleteMessage: 'Är du säker på att du vill ta bort fastigheten',
      apartments: 'Lokaler',
      searchPlaceholder: 'Sök fastigheter...',
      nocondominiumsForSearch: 'Inga fastigheter för sökningen "{{searchTerm}}"',
      nocondominiumsYet: 'Inga fastigheter.',
      selectSuperintendent: 'Välj förvaltare...',
      apartmentKeyType: 'Fastighetsnyckeltyp',
      selectCondominium: 'Välj fastighet',
      transfer: {
        toSubCompany: 'Överför till dotterbolag',
        transferredTooltip: 'Överförd till dotterbolag',
        transferredTo: 'Överförd till {{name}}',
        subCompanyCanEdit: 'Dotterbolaget kan redigera överförda data',
        revokeTransfer: 'Återkalla överföring',
        changeEditAccess: 'Ändra redigeringsåtkomst',
        selectSubCompany: 'Välj dotterbolag',
        confirmTransfer: 'Bekräfta överföring',
        transferSuccess: 'Överföring genomförd',
        revokeConfirm:
          'Är du säker på att du vill återkalla överföringen? Dotterbolaget förlorar åtkomst till fastigheten.',
        transferredAt: 'Överförd',
        back: 'Tillbaka',
        next: 'Nästa',
      },
    },
    controlPanel: {
      transferredCondominiums: 'Överförda fastigheter',
      personalDataPurge: {
        targetsHint: 'Personer är förvalda. Lägg till fastigheter, lokaler och nycklar vid behov.',
        peopleGroupHint: 'Personer, hyresvärdar och uthyrningssökande.',
        propertyGroupHint: 'Fastigheter, lokaler och nycklar hamnar i samma papperskorg i 7 dagar.',
        targetTypes: {
          resident: 'Personer',
          condominium: 'Fastigheter',
          apartment: 'Lokaler',
        },
        fields: {
          condominiumId: 'Fastighet',
          apartmentId: 'Lokal',
        },
        columns: {
          condominium: 'Fastighet',
        },
      },
    },
    messages: {
      selectResident: 'Välj person',
      apartmentCreated: 'Lokal skapad',
      apartmentsCreated: 'Lokaler skapade',
      apartmentUpdated: 'Lokal uppdaterad',
      apartmentDeleted: 'Lokal borttagen',
      apartmentsDeletedBulk: '{{count}} lokaler har tagits bort',
      saveApartmentSuccess: 'Lokal sparad',
      condominiumCreated: 'Fastighet skapad',
      condominiumUpdated: 'Fastighet uppdaterad',
      condominiumDeleted: 'Fastighet borttagen',
      condominiumsDeletedBulk: '{{count}} fastigheter har tagits bort',
      residentCreated: 'Person skapad',
      residentUpdated: 'Person uppdaterad',
      residentDeleted: 'Person borttagen',
      residentsDeletedBulk: '{{count}} personer har tagits bort',
      saveResidentSuccess: 'Person sparad',
      apartmentCreateFailed: 'Misslyckades med att skapa lokal',
      apartmentsCreateFailed: 'Misslyckades med att skapa lokaler',
      apartmentUpdateFailed: 'Misslyckades med att uppdatera lokal',
      apartmentDeleteFailed: 'Misslyckades med att ta bort lokal',
      saveApartmentFailed: 'Misslyckades med att spara lokal',
      condominiumCreateFailed: 'Misslyckades med att skapa fastighet',
      condominiumUpdateFailed: 'Misslyckades med att uppdatera fastighet',
      condominiumDeleteFailed: 'Misslyckades med att ta bort fastighet',
      residentCreateFailed: 'Misslyckades med att skapa person',
      residentUpdateFailed: 'Misslyckades med att uppdatera person',
      residentDeleteFailed: 'Misslyckades med att ta bort person',
      saveResidentFailed: 'Misslyckades med att spara person',
    },
    resident: {
      residentDetails: 'Personuppgifter',
      notFound: 'Person hittades inte',
      apartment: 'Lokal',
      noApartment: 'Ingen lokal',
      deleteTitle: 'Ta bort person',
      deleteMessage: 'Är du säker på att du vill ta bort personen "{{name}}"? Denna åtgärd kan inte ångras.',
    },
    dashboard: {
      myManagedProperties: 'Fastigheter jag hanterar',
      noProperties: 'Inga fastigheter att visa',
    },
    properties: {
      tabProperties: 'Fastigheter',
      tabApartments: 'Lokaler',
      tabResidents: 'Personer',
      createProperty: 'Skapa fastighet',
      createApartment: 'Skapa lokal',
      createResident: 'Skapa person',
      searchApartments: 'Sök lokaler...',
    },
    tooltips: {
      keys: {
        handoverInstructions:
          'Visas vid nyckelöverlämning och återlämning. Du kan ange instruktioner på företags-, fakturerings-, fastighets- och lokalnivå; lägre nivå ersätter högre nivå.',
      },
      wizard: {
        superintendent: 'Förvaltaren är personen som ansvarar för fastighetens dagliga förvaltning och underhåll.',
      },
      condominium: {
        businessId: 'Finskt FO-nummer i formatet 1234567-8. Valfritt, men rekommenderas för officiella fastigheter.',
      },
      apartments: {
        multiple: 'Skapa flera lokaler med löpnummer (t.ex. A1, A2, A3). Alla lokaler delar samma huvudadress.',
      },
      settings: {
        showMyProperties: 'Visa fastigheter där du är listad som förvaltare eller har särskilda rättigheter.',
        showBulkDelete:
          'Aktivera val och borttagning av flera objekt i tabeller (lokaler, personer, fastigheter, nycklar).',
      },
    },
    import: {
      condominiums: 'Fastigheter',
      apartments: 'Lokaler',
      residents: 'Personer',
      condominiumsInstructions: 'Importera fastigheter',
      condominiumsInstructionsDescription: 'Fyll minst i namn och adress. Övriga fält är valfria.',
      condominiumsFieldSuperIntendent: 'Förvaltare: Fullständigt namn (t.ex. "Matti Meikäläinen")',
      apartmentsInstructions: 'Importera lokaler',
      apartmentsInstructionsDescription: 'Adress och fastighet är obligatoriska.',
      apartmentsFieldCondominium: 'Fastighet: Namn på befintlig fastighet',
      keysFieldCondominium: 'Fastighet: Namn på befintlig fastighet (endast för huvudnycklar)',
      residentsInstructions: 'Importera personer',
      residentsInstructionsDescription: 'Namn, e-post och lokal krävs.',
      residentsFieldApartment: 'Lokal: Fullständig adress i formen "Gata, Postnummer Stad"',
      errors: {
        superintendentNotFound: 'Hittades inte',
        condominiumNotFound: 'Hittades inte',
        condominiumRequiredForGeneral: 'Fastighet krävs för huvudnyckeltyper',
        condominiumNotAllowedForNonGeneral: 'Fastighet kan inte anges för icke-huvudnyckeltyper',
      },
    },
    invitations: {
      condominium: 'Fastighet',
      apartment: 'Lokal',
      extraPermissions: 'Tilläggsbehörigheter',
      canDoUpkeeps: 'Kan utföra besiktningar',
      canRespondToServiceRequests: 'Kan svara på serviceförfrågningar',
      canSeeResidents: 'Kan se personer',
      canAccessAllApartments: 'Åtkomst till alla lokaler i fastigheten',
      canAccessAllKeys: 'Åtkomst till alla nycklar',
      canAccessAllServiceRequests: 'Åtkomst till alla serviceförfrågningar',
    },
    contractor: {
      property: 'Fastighet',
      apartment: 'Lokal',
      selectProperty: 'Välj fastighet',
      selectApartment: 'Välj lokal',
      keyAccessFilterCondominiumPlaceholder: 'Alla fastigheter',
      keyAccessFilterApartmentPlaceholder: 'Alla lokaler',
    },
    contractorDashboard: {
      properties: 'Fastigheter',
      apartments: 'Lokaler',
    },
    documentBank: {
      searchPlaceholder: 'Sök efter fastighet, lokal eller faktureringskonto…',
      sections: {
        condominiums: 'Fastigheter',
      },
    },
    events: {
      entityType: {
        resident: 'Person',
        apartment: 'Lokal',
        condominium: 'Fastighet',
        key: 'Nyckel',
        landlord: 'Hyresvärd',
      },
    },
    reports: {
      totalApartments: 'Lokaler',
      totalResidents: 'Personer',
      totalCondominiums: 'Fastigheter',
    },
    billingAccount: {
      addApartments: 'Lägg till lokaler',
      noUnassignedApartments: 'Inga olänkade lokaler.',
      noLinkedApartments: 'Inga lokaler är ännu kopplade till detta faktureringskonto.',
      linkPropertiesForRelatedLists:
        'Koppla minst en fastighet eller en lokal till detta faktureringskonto för att visa relaterad data.',
    },
    billing: {
      auditCondominium: 'Fastigheter',
      auditApartment: 'Lokaler',
      auditResident: 'Personer',
      auditKey: 'Nycklar',
      colCondominium: 'Fastighet',
      colApartment: 'Lokal',
    },
    landlordPortal: {
      allApartmentsOption: 'Alla lokaler',
    },
    residentNotifications: {
      tabTitle: 'Personunderrättelser',
      createTitle: 'Ny personunderrättelse',
      editTitle: 'Redigera personunderrättelse',
      deleteTitle: 'Ta bort personunderrättelse',
      scope: {
        wholeCondominium: 'Hela fastigheten',
        apartmentCount: '{{count}} lokaler',
      },
      field: {
        wholeCondominium: 'Hela fastigheten',
        wholeCondominiumHelp: 'Syns för alla lokaler under fastigheten i person- och hyresvärdportalerna.',
        apartments: 'Valda lokaler',
      },
      validation: {
        apartments: 'Välj minst en lokal eller hela fastigheten.',
      },
      portalTitle: 'Personunderrättelser',
    },
    maintenance: {
      needsAssessment: {
        selectCondominium: 'Välj fastighet för att filtrera listan.',
      },
    },
    upkeep: {
      allApartments: 'Alla lokaler',
      filterApartments: 'Filtrera lokaler',
      filterApartmentsPlaceholder: 'Ange namn, adress eller lokal',
      createApartmentInspections: 'Skapa lokalspecifika kontroller',
      selectCondominiums: 'Välj fastigheter',
      multiBatchAllApartmentsHelp: 'Skapar rader för alla lokaler i varje vald fastighet.',
      filterCondominiums: 'Filtrera fastigheter',
      filterCondominiumsPlaceholder: 'Ange fastighetsnamn eller adress',
      sendResidentNotification: 'Skicka personmeddelande',
      sendResidentNotificationHelp:
        'Samma meddelande skickas till personer i valda fastigheter (och visas i portaler).',
      batchCreatedWithNotification: 'Underhåll skapat ({{count}} rader) och personmeddelande skickat',
      multiBatchCreatedWithNotification:
        'Skapade {{batches}} underhållshelheter ({{count}} rader) och {{notices}} personmeddelanden',
      wizardStepLocationHelp:
        'Välj fastighet och vid behov lokal. Om ingen lokal väljs kan du välja flera lokaler samtidigt.',
      wizardStepLocationHelpEquipment:
        'Välj fastighet och vid behov lokal. Om ingen lokal väljs väljer du lokaler tillsammans med enheter i nästa steg.',
      locationProperty: 'Fastighet',
      locationSpace: 'Lokal',
      trackedAssetsHelpSingleApartment: 'Kontrollera enheter för denna lokal. En uppgift, en rapport.',
      trackedAssetsHelpSingleApartmentNamed: 'Kontrollera enheter för lokal {{apartment}}. En uppgift, en rapport.',
      trackedAssetsScopeApartment: 'Lokal: {{apartment}}',
      trackedAssetsHelpMultiApartment: 'Välj lokaler och deras enheter. En kontroll skapas per lokal med samma mall.',
      trackedAssetsEmpty: 'Inga enheter för vald fastighet',
      trackedAssetsEmptyApartment: 'Inga enheter i lokal {{apartment}}',
      trackedAssetsEmptySelectedApartment: 'Inga enheter för vald lokal',
      trackedAssetApartmentFilter: 'Filtrera efter lokal',
      trackedAssetApartmentFilterAll: 'Alla lokaler',
      targetApartments: 'Lokaler',
      targetApartmentsHelp: 'Välj lokaler som underhåll ska skapas för (en rapport per lokal).',
      targetApartmentsEquipmentHelp: 'Välj lokaler vars enheter ska kontrolleras. Varje lokal får en egen rapport.',
      targetApartmentsBatchHelp: 'Valfritt: välj flera lokaler för att skapa samma kontroll eller underhåll för varje.',
      targetApartmentsBatchCountHelp: 'Detta skapar {{count}} separata uppgifter, en per lokal.',
      targetApartmentsSelected: '{{count}} lokaler valda',
      targetApartmentsRequired: 'Välj minst en lokal',
      selectApartmentsBeforeDevices: 'Välj först lokaler, sedan deras enheter.',
      noApartmentsForProperty: 'Fastigheten har inga lokaler',
      batchCreated: 'Skapade {{count}} underhållsuppgifter (en per lokal)',
    },
    trackedAssets: {
      columnCondominium: 'Fastighet',
      filterCondominium: 'Filtrera fastighet',
      selectCondominium: 'Välj fastighet',
      apartment: 'Lokal',
      selectApartment: 'Välj lokal',
      mapEmptyHint: 'Koppla utrustningen till en fastighet eller lokal som har en adress.',
      bulkCreateUpkeepSameCondo: 'Välj endast enheter från samma fastighet.',
    },
    rentalBrokerage: {
      apartment: 'Lokal',
      resident: 'Person',
      landlord: 'Hyresvärd',
      createApartment: 'Skapa lokal',
      createResidentFromApplicant: 'Skapa person',
      createResident: 'Skapa person',
      createLandlord: 'Skapa hyresvärd',
      residentFromApplicant: 'Skapad / länkad från sökande',
      partyApplicantNeedsResident: 'Sökande: {{name}} — välj eller skapa en person',
      applyTitle: 'Ansök om lokalen',
      targetKind: {
        apartment: 'Lokal',
      },
    },
    residentPortal: {
      filesSectionTitle: 'Lokalens och fastighetens filer',
      apartment: 'Lokal',
      selectApartment: 'Välj lokal...',
    },
  },
};
